module.exports = __webpack_public_path__ + "img/waxlight-desktop.49f62b0a.webp";